/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type archiveNotificationsMutationVariables = {
  ids: Array<string>;
};
export type archiveNotificationsMutationResponse = {
  readonly invsysArchiveNotification: {
    readonly success: boolean;
  };
};
export type archiveNotificationsMutation = {
  readonly response: archiveNotificationsMutationResponse;
  readonly variables: archiveNotificationsMutationVariables;
};

/*
mutation archiveNotificationsMutation(
  $ids: [String!]!
) {
  invsysArchiveNotification(id: $ids) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'ids',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'id',
            variableName: 'ids',
          },
        ],
        concreteType: 'InvsysArchiveNotification',
        kind: 'LinkedField',
        name: 'invsysArchiveNotification',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'archiveNotificationsMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'archiveNotificationsMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: 'c9e82f056a14767ce0d126177281edee',
      id: null,
      metadata: {},
      name: 'archiveNotificationsMutation',
      operationKind: 'mutation',
      text: 'mutation archiveNotificationsMutation(\n  $ids: [String!]!\n) {\n  invsysArchiveNotification(id: $ids) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = '388d3b2a668169e3d4306f5023b290ba';
export default node;
